import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";

const ComplaintsTable = ({ complaints, onEdit, handleDelete, isDarkMode }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "قيد المراجعة": return "#f59e0b";
      case "مرفوض": return "red";
      case "تم الحل": return "#6FD943";
      default: return isDarkMode ? "#ddd" : "#6b7280";
    }
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        mt: 3,
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
      }}
    >
      <Table>
        <TableHead sx={{ bgcolor: isDarkMode ? "#333" : "#ddd" }}>
          <TableRow>
            {["نوع الشكوى", "التفاصيل", "الحالة", "الرد", "العمليات"].map((header) => (
              <TableCell
                key={header}
                align="center"
                sx={{
                  fontWeight: "bold",
                  color: isDarkMode ? "white" : "black",
                  fontSize: "18px",
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(complaints) && complaints.length > 0 ? (
            complaints.map((complaint) => (
              <TableRow key={complaint.id}>
                <TableCell align="center" sx={{ fontSize: "17px", color: isDarkMode ? "#ddd" : "#000" }}>{complaint.type}</TableCell>
                <TableCell align="center" sx={{ maxWidth: "300px", fontSize: "17px", color: isDarkMode ? "#ddd" : "#000" }}>{complaint.description}</TableCell>
                <TableCell align="center" sx={{ color: getStatusColor(complaint.status), fontSize: "17px" }}>
                  {complaint.status}
                </TableCell>
                <TableCell align="center" sx={{ maxWidth: "200px", fontSize: "17px", color: isDarkMode ? "#ddd" : "#000" }}>
                  {complaint.answer || "لم يتم الرد"}
                </TableCell>
                <TableCell align="center">
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#2196f3", mx: 1, my: 1 }}
                    onClick={() => onEdit(complaint)}
                  >
                    تعديل
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "#f44336", mx: 1, my: 1 }}
                    onClick={() => handleDelete(complaint.id)}
                  >
                    حذف
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ color: isDarkMode ? "#ddd" : "#000" }}>
                لا توجد شكاوى حتى الآن
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ComplaintsTable;
